import { render, staticRenderFns } from "./LError.vue?vue&type=template&id=963af52c"
import script from "./LError.vue?vue&type=script&lang=js"
export * from "./LError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports